
<div class="admin-layout">
  <Navbar />
  <div class="container is-fluid">
    <router-view />
  </div>
</div>
